//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {wechatorder, querywechatorderisok, queryuserordertype} from '../../api/pay'

export default {
  name: 'payCenter',
  data () {
    return {
      selectTitle: 0,
      isSend: true,
      urltag: 0,
      selectType: '',
      smsArr: [],
      voiceArr: [],
      showWarn: false,
      warnText: '',
      showSuccess: false,
      successText: ''
    }
  },
  created () {
    console.log('openid', this.$store.getters.get_openid)
    let host = window.location.host
    if (host === 'aimtycloud.anfangwx.aimtyiot.cn') {
      this.urltag = 1
    } else if (host === 'anfangwxtest.aimtyiot.cn') {
      this.urltag = 2
    } else {
      // anfangwxt.aimtyiot.cn
      this.urltag = 0
    }
    document.getElementsByTagName('title')[0].innerText = '支付中心'
    this.getOrderType()
  },
  mounted () {
    document.getElementsByTagName('title')[0].innerText = '支付中心'
  },
  beforeDestroy () {
    document.getElementsByTagName('title')[0].innerText = '智慧安防'
  },
  methods: {
    getOrderType () {
      queryuserordertype().then(res => {
        let arr = res.data.ordertypes
        for (let i = 0; i < arr.length; i++) {
          let obj = arr[i]
          obj.showType = ''
          let type = obj.order_type.slice(0, 3)
          console.log(type)
          if (type === 'sms') {
            obj.showType = 'sms'
          } else if (type === 'voi') {
            obj.showType = 'voice'
          } else {
            obj.showType = 'push'
          }
          this.smsArr.push(obj)
        }
      }).catch(() => {})
    },
    openTitleSelect (index) {
      this.selectType = ''
      this.selectTitle = index
    },
    backPage () {
      this.$router.push('/payDetails')
    },
    changeType (item) {
      this.selectType = item
    },
    sendPay () {
      if (this.$store.getters.get_openid === '' || this.selectType === '') {
        return
      }
      let data = {
        openid: this.$store.getters.get_openid,
        ordertype: this.selectType.order_type,
        urltag: this.urltag,
        ordertypeid: this.selectType.id
      }
      let vm = this
      wechatorder(data).then(res => {
        // eslint-disable-next-line
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', res.data,
          function (res) {
            console.log(res)
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              // 使用以上方式判断前端返回,微信团队郑重提示：
              // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              vm.showSuccess = true
              vm.successText = '支付成功'
              // vm.getOrderIsOk()
              setTimeout(() => {
                vm.$router.push('/More')
              }, 3000)
            }
            if (typeof WeixinJSBridge === 'undefined') {
              if (document.addEventListener) {
                // eslint-disable-next-line
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
              } else if (document.attachEvent) {
                // eslint-disable-next-line
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
                // eslint-disable-next-line
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
              }
            } else {
              // eslint-disable-next-line
              onBridgeReady()
            }
          })
        // this.getOrderIsOk()
      }).catch(() => {})
    },
    getOrderIsOk () {
      if (this.$store.getters.get_openid === '') {
        return
      }
      let data = {
        openid: this.$store.getters.get_openid,
        orderid: 3,
        urltag: this.urltag
      }
      querywechatorderisok(data).then(res => {
        if (res.data.isok === 'SUCCESS') {
          this.showSuccess = true
          this.successText = '支付成功'
        } else if (res.data.isok === 'REFUND') {
          this.showWarn = true
          this.warnText = '转入退款'
        } else if (res.data.isok === 'NOTPAY') {
          this.showWarn = true
          this.warnText = '未支付'
        } else if (res.data.isok === 'CLOSED') {
          this.showWarn = true
          this.warnText = '已关闭'
        }
        let vm = this
        setTimeout(() => {
          vm.$router.push('/More')
        }, 3000)
      }).catch(() => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/more/payCenter.vue